import { useAuth } from './context/AuthContext';
import { useRouter } from './context/RouterContext';
import CallbackHandler from './components/CallbackHandler';
import LogoutHandler from './components/LogoutHandler';
import LandingPage from './pages/LandingPage';
import VocabulariesPage from './pages/VocabulariesPage';
import SchemasPage from './pages/SchemasPage';
import DatabasePage from './pages/DatabasePage';
import AccessDeniedPage from './pages/AccessDeniedPage';
import VersionInfo from './components/VersionInfo';

function App() {
  const { loading, loggingOut } = useAuth();
  const { pathname } = useRouter();

  // Show logout screen during logout process
  if (loggingOut) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'white'
      }}>
        <img 
          src="/lendport_logo_icon_text.svg" 
          alt="Lendport" 
          style={{ 
            width: '180px', 
            opacity: 0.3,
            filter: 'grayscale(100%)',
            marginBottom: '30px'
          }} 
        />
        <div style={{
          width: '200px',
          height: '2px',
          background: 'linear-gradient(90deg, transparent, #e5e7eb, transparent)',
          marginBottom: '30px',
          animation: 'pulse 1.5s ease-in-out infinite'
        }}></div>
        <h2 style={{ color: '#6b7280', fontWeight: '400', fontSize: '16px' }}>Logging out...</h2>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'white'
      }}>
        <img 
          src="/lendport_logo_icon_text.svg" 
          alt="Lendport" 
          style={{ 
            width: '180px', 
            opacity: 0.3,
            filter: 'grayscale(100%)',
            marginBottom: '30px'
          }} 
        />
        <div style={{
          width: '200px',
          height: '2px',
          background: 'linear-gradient(90deg, transparent, #e5e7eb, transparent)',
          marginBottom: '30px'
        }}></div>
        <h2 style={{ color: '#6b7280', fontWeight: '400', fontSize: '16px' }}>Verifying authentication...</h2>
      </div>
    );
  }

  // Routing
  if (pathname === '/callback') {
    return <CallbackHandler />;
  }

  if (pathname === '/logout') {
    return <LogoutHandler />;
  }

  if (pathname === '/access-denied') {
    return <AccessDeniedPage />;
  }

  if (pathname === '/vocabularies' || pathname === '/interactive') {
    return <VocabulariesPage />;
  }

  if (pathname === '/schemas') {
    return <SchemasPage />;
  }

  if (pathname === '/database') {
    return <DatabasePage />;
  }

  // Default: Landing page
  return (
    <>
      <LandingPage />
      <VersionInfo />
    </>
  );
}

export default App;
